import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FullTextField from "../commonControls/FullTextField";
import { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { forgetPasswordRoute } from "../../routes/apiRoutes";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { OTPVerifyRoute, loginRoute } from "../../routes/reactRoutes";
import { LogoAndText } from "../../theme/JaziTheme";
import { Link } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import axiosInstance from "../../axios/axiosInstance";
import { t } from "i18next";
import FlipLanguageSwitcher from "./FlipLanguageSwitcher";

const ForgetPassword = (props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(
    () => {
      document.title = props.title;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const schema = yup.object({
    email: yup
      .string()
      .email(t("emailinvalid"))
      .required(t("emailisrequired")),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        // send data to server
        const { data } = await axiosInstance.get(
          `${forgetPasswordRoute}${values.email}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (data.statusCode === 200 || data.statusCode === 201) {
          toast.dismiss();
          toast.success(t("forgotpasswordEmailsent"), {
            autoClose: 1000,
          });
          setLoading(false);
          navigate(OTPVerifyRoute, { state: { email: values.email } });
        } else if(data.statusCode === 409) {
          toast.dismiss();
          toast.error(t("usernotfound"), { autoClose: false });
          setLoading(false);
          formik.resetForm();
        }
        else {
          toast.dismiss();
          setLoading(false);
          formik.resetForm();
          toast.error(t("unexpectedserverresponse"), { autoClose: false });
        }
      } catch (error) {
        toast.dismiss();
        if(error.response?.data?.statusCode === 409) {
          toast.error(t("nouseragainstemail"), { autoClose: false });
        } else {
          toast.error(t("forgotpasswordError"), { autoClose: false });
        }
        formik.resetForm();
        setLoading(false);
      }
    },
  });

  const outerBox = {
    background: theme.palette.whiteblack.main,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    //border: `0.5px solid ${theme.palette.componentBackgrounds.main}`,
    borderRadius: 1,
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
    py: 5,
    px: 2,
    maxWidth: 500,
    maxHeight: 525,
    width: "100%",
  };
  const formStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: "90%",
    gap: 2.5,
  };
  const formStyle2 = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "100%",
  };
  const rootStyle = {
    display: "grid",
    placeItems: "center",
    height: `100vh`,
    background: theme.palette.primary.main,
    backgroundImage: 'url("background.webp")',
    backgroundSize: "cover",
  };
  useEffect(() => {
    Object.keys(formik.touched).forEach((field) => {
      try {
        formik.validateField(field);
      } catch {}
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme.direction]);

  return (
    <div dir={theme.direction} style={rootStyle}>
      <Paper elevation={1} sx={outerBox}>
        <Box
          sx={{ display: "flex", justifyContent: "center", mb: 2, zoom: 0.8 }}
        >
          <LogoAndText />
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "90%",
            alignItems: "center",
            textAlign: "left",
            mb: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "1.25rem",
              fontWeight: 800,
              textAlign: "left",
              alignSelf: "center",
              flexGrow: 1,
            }}
          >
            {t("forgotPassword?")}
          </Typography>
          <FlipLanguageSwitcher />
        </Box>
        <form style={formStyle2} onSubmit={formik.handleSubmit}>
          <Box sx={formStyle}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                mt: 4.6,
                alignItems: "center",
              }}
            >
              <Typography
                    sx={{ textAlign: "left", width: "100%", fontWeight: 600 }}
              >
                {`${t("emailAddress")}*`}
              </Typography>
              <FullTextField
                id="profile-email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                name="email"
                label={`${t("enterYourEmail")}*`}
                // title={`${t("enterYourEmail")}*`}
              />
            </Box>
          </Box>
          <Box sx={{ width: "90%" }}>
            <LoadingButton
              type="submit"
              loading={loading}
              variant="contained"
              sx={{
                width: "100%",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "1rem",
                my: 2.5,
                py: 1.5,
              }}
            >
              <span>{t("sendEmail")}</span>
            </LoadingButton>
          </Box>
        </form>
        <Link
          to={loginRoute}
          style={{
            fontSize: "0.9375rem",
            fontWeight: 700,
            color: theme.palette.whiteblack.contrastText,
          }}
        >
          {t("gotologin")}
        </Link>
      </Paper>
    </div>
  );
};
export default ForgetPassword;
